"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const styles = (0, react_1.css) `
  width: 40px;
  height: 40px;
  margin: 0 auto;

  ::after {
    content: ' ';
    display: block;
    width: 30px;
    height: 30px;
    margin-top: 10px;
    border-radius: 50%;
    border: 4px solid;
    border-color: #fff transparent;
    animation: ring-animation 1s linear infinite;
  }

  @keyframes ring-animation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;
function ProgressIndicator() {
    return (0, jsx_runtime_1.jsx)("div", { css: styles });
}
exports.default = ProgressIndicator;
